import React, { useState, useContext } from 'react'
import PropTypes from 'prop-types';
import { SearchContext } from 'context/searchContextWrapper'; 


const SearchBarInput = React.forwardRef(({
    defaultVal,
    debounceOnChange,
    isShowingPlaceholder,
    location,
    handleKeyDown,
    setToggleOpen,
    focusIndex,
    setFocusIndex
}, ref) => {

    const searchState = useContext(SearchContext) || { defaultSearch: 'Search' };
    const [placeholder] = useState(searchState.defaultSearch);
    
    return(
      <input
        ref={ref}
        className={`${
          isShowingPlaceholder || location?.pathname !== '/search' ? '' : 'input-placeholder'
        } ${focusIndex === -1 ? 'focused' : ''}`}
        aria-label="fusion-docs-search"
        type="text"
        placeholder={isShowingPlaceholder ? 'Search' : placeholder}
        defaultValue={defaultVal}
        onChange={e => {debounceOnChange(e.target.value);}}
        onKeyDown={handleKeyDown}
        onClick={() => setToggleOpen(true)}
        onMouseEnter={() => {
          setFocusIndex(-1)
        }}
        maxLength={50}
      />
    )
})

SearchBarInput.displayName = 'SearchBarInput'

SearchBarInput.propTypes = {
    defaultVal: PropTypes.string.isRequired,
    debounceOnChange: PropTypes.func.isRequired,
    isShowingPlaceholder: PropTypes.bool.isRequired,
    handleKeyDown: PropTypes.func.isRequired,
    setToggleOpen: PropTypes.func.isRequired,
    location: PropTypes.object.isRequired,
    focusIndex: PropTypes.number.isRequired,
    setFocusIndex: PropTypes.func.isRequired
}

export default SearchBarInput